import { translate } from '../../ContentTranslation';
import React, { Component } from 'react';
import Lightbox from '../../components/utility/Lightbox';
import { Tooltip } from 'reactstrap';
import Img from '../../StableImage';
import Champion from './Champion';
import Companion from './Companion';
import Fight from './Fight';
import Shop from './Shop';
import Fountain from './Fountain';
import Treasure from './Treasure';
import Entity from './Entity';
import Celestial from './Celestial';
import Collectable from './Collectable';
import NavigationArrow from './NavigationArrow';
import Library from '../utility/Library';
import tooltipEffect from '../utility/tooltipEffect';
import MainButton from '../../components/buttons/MainButton';
import { read, getLanguage } from '../../TextManager';
import './Room.css';

const rewardToIcon = {
  relic: "relic2",
  runes: "rune",
  insight: "insight",
  card: "card",
  shards: "soulshard",
  item: "unknown",
  remove: "remove",
  berry: "berry",
  coin: "coin",
  seed: "seed",
  soul: "soul",
  paws: "paws",
  key: "key"
}

const rewardToName = {
  relic: read('cards/relic'),
  insight: read('scene/insight'),
  card: read('scene/card'),
  runes: translate("Runes"),
  shards: read('scene/shards'),
  item: translate("Item"),
  remove: translate("Remove"),
  paws: translate("Token"),
  key: translate("Key"),
  berry: read('scene/healing'),
  coin: read('scene/gold'),
  seed: read('scene/exp'),
  soul: translate("Soul")
}

const statuses = Object.values(Library.statuses);
const POWER_ORB_RELICS = ["power-orb", "power-orb-2"];

export default class Room extends Component {

  constructor (props) {

    super(props);
    this.canSelect = false;
  }

  componentDidMount() {

    setTimeout(() => this.canSelect = true, 600);
  }

  state = {

    tooltip: null
  }

  toggleTooltip (tooltip, touch) {

    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
      return;

    if (touch) {
      
      if (this.tooltipTimeout)
        clearTimeout(this.tooltipTimeout);

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      this.tooltipTimeout = setTimeout(() => this.toggleTooltip(null), 3000);
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  roomIndicator (room) {

    switch (room.type) {
    case "shop": return <div className="room-indicator"><div className="room-indicator-main"><Img key={room.x + "-" + room.y + "-" + "icon"} src="/images/shop.png"/><h3>{read('scene/shop')}</h3></div></div>;
    case "fountain": return <div className="room-indicator"><div className={"room-indicator-main"}><Img key={room.x + "-" + room.y + "-" + "icon"} src="/images/fountain.png"/><h3>{read('scene/fountain')}</h3></div></div>;
    case "boss": return <div className="room-indicator"><div className="room-indicator-main"><Img key={room.x + "-" + room.y + "-" + "icon"} src="/images/boss.png"/><h3>{read('scene/boss')}</h3></div></div>;
    case "treasure": return <div className="room-indicator"><div className={"room-indicator-main"}><Img key={room.x + "-" + room.y + "-" + "icon"} src="/images/treasure.png"/><h3>{read('scene/treasure')}</h3></div></div>;
    case "event": return <div className="room-indicator"><div className="room-indicator-main"><Img key={room.x + "-" + room.y + "-" + "icon"} src="/images/unknown.png"/><h3>{read('scene/unknown')}</h3></div></div>;
    case "menagerie": return <div className="room-indicator"><div className="room-indicator-main"><Img key={room.x + "-" + room.y + "-" + "icon"} src="/images/menagerie.png"/><h3>{read('scene/menagerie')}</h3></div></div>;
    case "fight": return (
      <div className="room-indicator">
        {
          Array.isArray(room.reward) ?
          <div className="room-indicator-main">
            <Img key={room.index + "-" + "icon"} src={"/images/" + rewardToIcon[room.reward[0]] + ".png"}/>
            <Img key={room.index + "-" + "icon2"} src={"/images/" + rewardToIcon[room.reward[1]] + ".png"}/>
            <h3>{rewardToName[room.reward[0]]} & {rewardToName[room.reward[1]]}</h3>
          </div> :
          <div className="room-indicator-main">
            <Img key={room.index + "-" + "icon"} src={"/images/" + rewardToIcon[room.reward] + ".png"}/>
            <h3>{rewardToName[room.reward]}</h3>
          </div>
        }
        <div className="room-indicator-second">
          {read('scene/' + room.difficulty)}
        </div>
      </div>
    );
    default:
      return <div className="room-indicator"><div className="room-indicator-main"><h3>{translate("Empty")}</h3></div></div>;
    }

  }

  parseDescription(description) {
    const parts = [];
    let lastIndex = 0;

    // Match things like [status] or {card}
    const regex = /\[([^\]]+)\]|\{([\w-]+)\}/g;
    let match;

    while ((match = regex.exec(description)) !== null) {
      // Push the text before the match
      if (match.index > lastIndex) {
        parts.push(description.slice(lastIndex, match.index).replace(' ', '\u00A0'));
      }

      if (match[1]) {
        // Matched [status]
        const el = match[1];
        const status = statuses.find(s => s.name === el || s.translations?.en?.name === el);
        parts.push(
          status?.type === "curse" ?
          <span key={parts.length}>{status.translations?.[getLanguage()]?.name || el}</span> :
          <span key={parts.length} className={
            "choice-keyword keyword" +
            (status?.effect ? "" : " unlabelled") +
            (status?.soft ? " soft" : "")
          }>
            {status?.keyword ? "" : <Img className="keyword-icon" src={`/images/statuses/${el}.png`} alt="" />}
            {status?.name || el}
          </span>
        );
      } else if (match[2]) {
        // Matched {card}
        const el = match[2];
        const card = Library.getUpgradedCard(el);
        parts.push(
          <span key={parts.length} className="choice-card-name">
            {read('cards/categoryseparator')}{card?.name || el}
          </span>
        );
      }

      lastIndex = regex.lastIndex;
    }

    // Add the remaining text after the last match
    if (lastIndex < description.length) {
      parts.push(description.slice(lastIndex).replace(' ', '\u00A0'));
    }

    return <span>{tooltipEffect(description, parts)}</span>;
  }

  previewCard (event, key) {
    event.stopPropagation();
    if (!this.canSelect)
      return;
    const card = Library.getCard(key);
    if (card)
      this.props.manager.setState({focus: Library.upgradeItem(card, this.props.manager.run.power)});
  }

  render () {

    let tooltips = []

    let src = this.props.src;
    let manager = this.props.manager;

    let model = src.model ? src.model.model || src.model : undefined;
    let closer = model && model.script && model.script.type === "choice";
    const powerOrbIndex = src.type === "start" ? src.collectables.findIndex(col => col?.type === "relic" && POWER_ORB_RELICS.includes(col.value?.key)) : -1;
    const powerOrb = powerOrbIndex >= 0 ? src.collectables[powerOrbIndex] : null;
    const nextCelestialKey = src.type === "boss" ? manager.run.previewCelestial() : null;
    const nextCelestial = nextCelestialKey ? Library.getSpirit(nextCelestialKey) : null;

    let plan = null;
    if (this.props.plan.length > 0)
      plan = this.props.plan[0];

    return (
      <div className={"room-scene" + (src.celestial?.active ? " spirit-room" : "")}>
        {
          this.state.warning &&
          <Lightbox className="lightbox-warning" open={ true } onClose={ () => this.setState({warning: null}) }>
            <div className="options-warning">{this.state.warning}</div>
            <MainButton>{translate("Proceed")}</MainButton>
          </Lightbox>
        }
        {
          (!src.fight || src.fight.done) &&
          <Champion key={src.x + "-" + src.y + "-" + "champion"} src={src.run.champion} onSelect={() => {}}/>
        }
        {
          (!src.fight || src.fight.done) && src.run.companion &&
          <Companion key={src.x + "-" + src.y + "-" + "companion"} src={src.run.companion} onSelect={() => {}}/>
        }
        {
          src.shop &&
          <Shop src={src.shop} manager={this.props.manager}/>
        }
        {
          src.fountain &&
          <Fountain src={src.fountain} manager={this.props.manager}/>
        }
        {
          src.treasure &&
          <Treasure src={src.treasure} manager={this.props.manager}/>
        }
        {
          src.celestial &&
          <Celestial src={src.celestial} manager={this.props.manager}/>
        }
        {
          src.fight && !src.fight.done &&
          <Fight src={src.fight} manager={this.props.manager}/>
        }
        {
          (!src.fight || src.fight.done) && src.type !== "boss" && !src.choices && !src.run.storyEvent && !src.celestial?.active && !(src.type === "start" && src.collectables.some(col => col)) &&
          <div key={src.x + "-" + src.y + "-" + "navigation"} className="room-navigation">
          {
            src.run.nextRooms && src.run.nextRooms.map((room,i) =>
              <NavigationArrow
                key={src.run.time + "-navigate-" + i}
                onClick={() => {
                  if (src.run.time === this.props.manager.run.time)
                    this.props.manager.run.continueTo(i);
                }}
                className={"room-navigate room-navigate-" + (i === 0 && src.run.nextRooms.length === 1 ? "north" : (room.index === model.index ? "north" : (room.index > model.index ? "east" : "west"))) + (plan !== undefined && plan !== null ? (room.index === plan ? " room-navigate-treasure" : "") : " room-navigate-" + (room.type === "fight" && room.difficulty === "hard" ? "hard-" : "") + room.type) }>
                {this.roomIndicator(room)}
              </NavigationArrow>
            )
          }
          </div>
        }
        {
          (!src.fight || src.fight.done) && src.type === "boss" && !src.run.storyEvent &&
          <div key={src.x + "-" + src.y + "-" + "navigation"} className="room-navigation">
            {/*<div key="escape" onClick={() => this.props.manager.run.victory()} className="room-navigate room-navigate-north room-navigate-escape">
              <div className="room-indicator">
                <div className="room-indicator-main">
                  <Img key={"escape-icon"} src="/images/escape.png"/>
                  <h3>Escape</h3>
                </div>
                <div className="room-indicator-second">Save your progress</div>
              </div>
            </div>*/}
            <NavigationArrow key="celestial" onClick={() => this.props.manager.run.enterCelestialRoom()} className={"room-navigate room-navigate-north room-navigate-celestial room-navigate-celestial-" + nextCelestial.key}>
              <div className="room-indicator">
                <div className="room-indicator-main">
                  <Img key={"celestial-icon"} src={"/images/" + nextCelestial.key + ".png"}/>
                  <h3>{nextCelestial.name}</h3>
                </div>
              </div>
            </NavigationArrow>
          </div>
        }
        <div className={"room-entities" + (closer ? " closer-entities" : "")}>
        {
          src.entities.map((entity, i) => <Entity static={entity.static} key={"room-entity-" + i + "-" + src.x + "-" + src.y + "-" + src.run.floor} src={ Object.assign({key: i}, entity) } onSelect={() => {}}/> )
        }
        {
          src.celestial && <div className="spirit-orb-wrapper">
            <div className="spirit-orb-outside" onClick={() => this.props.manager.run.room.celestial.activate()}>
              <div className="spirit-orb">
                <span className="spirit-core" />
              </div>
            </div>
          </div>
        }
        </div>
        {
          powerOrb &&
          <div className="power-orb-holder">
            <Collectable
              id={"power-orb-holder-" + powerOrbIndex}
              key={"power-orb-holder-" + powerOrbIndex}
              className="power-orb-held-collectable"
              manager={this.props.manager}
              onSelect={() => this.props.manager.run.room.collect(powerOrbIndex)}
              src={powerOrb}/>
          </div>
        }
        { 
          src.type !== "start" && <div className="room-collectables">
          {
            src.collectables.map((col,i) => {
              if (i === powerOrbIndex)
                return <div key={"empty-reward-" + i} className="empty-reward"/>;
              if (!col)
                return <div key={"empty-reward-" + i} className="empty-reward"/>;
              return <Collectable id={col.type + "-room-reward-" + i} key={col.type + "-room-reward-" + i} manager={this.props.manager} onSelect={() => this.props.manager.run.room.collect(i)} src={col}/>;
            })
          }
          </div>
        }
        {
          src.collectables.filter(col => col).length > 0 && !powerOrb && <div className="collect-all"><span onClick={() => this.props.manager.run.room.collectAll()}>{read('scene/collectall')}</span></div>
        }

        {
          src.choices &&
          <div className="fountain-choices">
            <div key="fountain-choice-text" className="fountain-choice-text">
              { src.choiceText }
            </div>
          {
            src.choices.map((c,i) => {
              const previewCards = [...new Set(Array.from(c.description.matchAll(/\{([\w-]+)\}/g), match => match[1]))]
                .filter(key => Library.getCard(key));
              return <div key={i} className={"fountain-choice" + (manager.run.room.canSelectChoice(i) ? "" : " locked")} onClick={() => manager.run.room.selectChoice(i)}>
                  <div className="fountain-choice-inner">
                    <h3>{c.name}</h3>
                    {this.parseDescription(c.description)}
                  </div>
                  {
                    previewCards.map((key, cardIndex) =>
                    <div key={key} className="shop-article-info" style={{right: `${cardIndex * 7}vh`}} onClick={e => {
                      this.previewCard(e, key);
                    }}>
                      <Img src="/images/info.png"/>
                    </div>)
                  }
                </div>;
            })
          }
          </div>
        }
      </div>
    );
  }
}

